import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import UpdatingBlock from 'components/common/UpdatingBlock'
import { Column } from '../Common.styles'
import TireControl from './components/TireControl'
import AddToQuoteButton from './components/AddToQuoteButton'
import { FavoriteLink } from 'components/MyFavorites/FavoriteButton'
import Media from 'components/common/Media'
import TireAvailability from 'components/common/TireAvailability'
import { ADDING_TO_SHOPPING_QUOTE } from 'components/common/UpdatingBlock/constants'
import useTireAvailabilityStatus from 'src/hooks/useTireAvailabilityStatus.js'
import { isInventoryStatusLoaded } from 'helpers/utils'

const TireCost = ({
  model,
  front,
  rear,
  skuId,
  staggeredSkuId,
  rearSkuId,
  hasRearTire,
  quantityInputId,
  zeroPriceItemMessage,
  isCompatible,
  showSelectLocationLinkInsteadOfPrice,
  showStoreLocatorModal,
  name,
  mainImageUrl,
  brandLogo,
  frontTire,
  rearTire,
  oeFlag,
  evFlag,
  brandName,
  storeNumber,
  inventoryStatuses,
  isPilotStore
}) => {
  /* this custom hook is designed to make inventory service call when PDP page loads
  and when quantity is updated */
  const [availability] = useTireAvailabilityStatus({
    countFront: front.quantity,
    countRear: rear.quantity,
    brandName,
    frontTireBvId: front.frontTireBvId,
    rearTireBvId: rear.rearTireBvId,
    storeNumber,
    dependencies: [front.quantity, rear.quantity, isPilotStore],
    productSkuId: staggeredSkuId || skuId,
    isPilotStore
  })

  const renderTireAvailability = (isPilotStore
    ? (
      <AvailabilityWrapper>
        <TireAvailability availability={ availability } />
      </AvailabilityWrapper>
    )
    : null
  )

  return (
    <Form noValidate>
      <UpdatingBlock
        name={ ADDING_TO_SHOPPING_QUOTE }
        value={ staggeredSkuId || skuId }
        condition={ isInventoryStatusLoaded(inventoryStatuses, staggeredSkuId || skuId) }>
        {renderTireAvailability}
        <div>
          <Column responsive>
            <TireControl
              { ...front }
              altTire={ rear }
              zeroPriceItemMessage={ zeroPriceItemMessage }
              quantityInputId={ quantityInputId }
              showSelectLocationLinkInsteadOfPrice={ showSelectLocationLinkInsteadOfPrice }
              handleSelectLocationLinkClick={ showStoreLocatorModal }
              model={ model.frontTire } />
          </Column>
          {
            hasRearTire &&
            <Column responsive>
              <TireControl
                { ...rear }
                altTire={ front }
                zeroPriceItemMessage={ zeroPriceItemMessage }
                quantityInputId={ quantityInputId }
                showSelectLocationLinkInsteadOfPrice={ showSelectLocationLinkInsteadOfPrice }
                handleSelectLocationLinkClick={ showStoreLocatorModal }
                model={ model.rearTire } />
            </Column>
          }
        </div>
        <Column responsive>
          <AddToQuoteButton
            disabled={ !isCompatible }
            productInfo={{
              skuId,
              quantity: front.quantity,
              rearSKUQuantity: rear.quantity,
              rearSkuId,
              oeFlag,
              evFlag,
              staggeredSkuId }} />

          {isCompatible && (
            <FavoriteLinkHeart
              skuId={ staggeredSkuId || skuId }
              tireLineName={ name }
              imageUrl={ mainImageUrl }
              brandLogoUrl={ brandLogo }
              countFront={ front.quantity }
              countRear={ rear.quantity }
              frontTireSize={ frontTire && frontTire.tireSize }
              rearTireSize={ rearTire && rearTire.tireSize } />
          )}

        </Column>
      </UpdatingBlock>
    </Form>)
}

export default TireCost

TireCost.propTypes = {
  brandLogo: PropTypes.string,
  brandName: PropTypes.string,
  evFlag: PropTypes.bool,
  front: PropTypes.shape({
    quantity: PropTypes.number,
    frontTireBvId: PropTypes.string
  }),
  frontTire: PropTypes.shape({
    tireSize: PropTypes.string
  }),
  hasRearTire: PropTypes.bool,
  inventoryStatuses: PropTypes.arrayOf(PropTypes.shape()),
  isCompatible: PropTypes.bool,
  isPilotStore: PropTypes.bool,
  mainImageUrl: PropTypes.string,
  model: PropTypes.shape({
    frontTire: PropTypes.shape(),
    rearTire: PropTypes.shape()
  }),
  name: PropTypes.string,
  oeFlag: PropTypes.bool,
  quantityInputId: PropTypes.string,
  rear: PropTypes.shape({
    quantity: PropTypes.number,
    rearTireBvId: PropTypes.string
  }),
  rearSkuId: PropTypes.string,
  rearTire: PropTypes.shape({
    tireSize: PropTypes.string
  }),
  showSelectLocationLinkInsteadOfPrice: PropTypes.bool,
  showStoreLocatorModal: PropTypes.func,
  skuId: PropTypes.string,
  staggeredSkuId: PropTypes.string,
  storeNumber: PropTypes.string,
  zeroPriceItemMessage: PropTypes.string
}

const Form = styled.div`
  ${Mixin.responsive('padding', '20px 0 25px', '20px 0 30px')}
  ${Mixin.responsive('margin', '0 auto', '0 16px')}
  margin: 0 auto;
  color: ${Theme.colors.black};
`

const FavoriteLinkHeart = styled(FavoriteLink)`
  ${Media.desktop`
    display: block;
  `}
  ${Mixin.responsive('margin', '15px 0 0 20%', '25px 0 0 0')}
`
const AvailabilityWrapper = styled.div`
  margin-bottom: 20px;
`
